import {Cureus} from '../Cureus';

Cureus.ArticleIndex= {}
//= require_tree ./ArticleIndex